import MyResults from './MyResults';

export default MyResults;
